module.exports = __webpack_public_path__ + "img/CUBIC_LOGO.3e64c97f.png";